// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SkipNextAutoDeliveryModel, skipNextOrder } from "@guestsupply/App/Services/AutoDelivery";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

type HandlerType = ApiHandler<
    SkipNextAutoDeliveryModel & HasOnSuccess & HasOnError<string>,
    ServiceResult<SkipNextAutoDeliveryModel> & {
        errorMessage?: string;
    }
>;

export const CallSkipNextAutoDeliveryApi: HandlerType = async props => {
    const { productId } = props.parameter;

    const skipNextAutoDeliveryOrderResult = await skipNextOrder({
        productId,
    });
    props.apiResult = skipNextAutoDeliveryOrderResult;
};
export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.();
    }
};
export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};
export const chain = [CallSkipNextAutoDeliveryApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const skipNextAutoDeliveryOrder = createHandlerChainRunner(chain, "skipNextAutoDeliveryOrder");
export default skipNextAutoDeliveryOrder;
